import {
  canAccessExpansionFieldRoles,
  ENGINEERING_TAB_EDITOR_ROLE_PATTERNS,
} from "./commercialRoleAccess";
import { getViewerEmailFromStorage } from "./userMatrixStorage";
import { isPluginEnabled, PLUGIN_IDS } from "./registry";

export const INTERCONNECTS_EDITOR_ROLE_PATTERNS = [
  ...ENGINEERING_TAB_EDITOR_ROLE_PATTERNS,
  "project manager",
  "coordinator",
];

/** Inline grid edits on the Interconnects registry page. */
export const INTERCONNECTS_GRID_EDITOR_ROLE_PATTERNS = ["administrator", "drafter"];

export function interconnectsPluginEnabled() {
  return isPluginEnabled(PLUGIN_IDS.INTERCONNECTS);
}

export function canViewInterconnects(viewerEmail) {
  if (!interconnectsPluginEnabled()) return false;
  return canAccessExpansionFieldRoles(INTERCONNECTS_EDITOR_ROLE_PATTERNS, viewerEmail, {
    includeCoordinator: true,
  });
}

export function canManageInterconnects(viewerEmail) {
  return canViewInterconnects(viewerEmail);
}

export function canEditInterconnectsGrid(viewerEmail) {
  if (!interconnectsPluginEnabled()) return false;
  return canAccessExpansionFieldRoles(INTERCONNECTS_GRID_EDITOR_ROLE_PATTERNS, viewerEmail);
}

export function getInterconnectsViewerEmail() {
  return getViewerEmailFromStorage();
}
